import BackendAIService from './backendAI';
import { API_BASE_URL } from '../config/api';

// 创建后端AI服务实例
const backendAI = new BackendAIService({
  baseUrl: API_BASE_URL, // 自动根据环境选择API地址
  authToken: '550e8400-e29b-41d4-a716-446655440000', // 测试用户token
});

export default backendAI;
